import { useState } from 'react';
import styled from 'styled-components';
import { MultiSelect } from 'react-multi-select-component';
import { useLocalization } from '../custom-hooks/useLocalization';
import { withLocalization } from '../shared/Context/LocalizationContext';

import { device } from '../../utils/styled-component-mixins';
import TransactionCard from './cards/TransactionCard';

// https://github.com/Arif-un/react-multiple-select-dropdown-lite
const FilterDivStyled = styled.div`
  .filter-selection-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    justify-content: center;
    padding: 2rem 0;

    @media ${device.desktop} {
      flex-direction: row;
      padding: 4rem 0;
    }
  }

  .filter-selection-item {
    flex: 1 1 100%;
    max-width: 100%;

    label {
      font-weight: bold;
    }
  }

  .filter-area-container {
    background-color: white;
    box-shadow: var(--card-shadow);
    margin-bottom: 8rem;
    margin-top: 4rem;
    padding: 3rem 4.5rem;

    @media ${device.desktop} {
      margin-bottom: 4rem;
      margin-top: 4rem;
    }
  }

  fieldset {
    border: none;
    min-width: 100%;
    padding: 0;
    margin: 0;
  }

  .multi-select {
    border-radius: 0;
    width: 100%;
  }

  .transactions-container {
    padding-top: 1rem;

    @media ${device.desktop} {
      margin: 0rem 20rem;
    }
  }

  .transaction-item-container {
    background-color: white;
    box-shadow: var(--card-shadow);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100%;
    justify-content: center;
    position: relative;
    padding: 2rem 2rem;
    width: 100%;
  }

  .transaction-section-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    margin-top: 10rem;
    padding-bottom: 10rem;
    justify-content: center;
    align-items: center;

    @media ${device.tablet} {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      row-gap: 1.6rem;
      column-gap: 1.6rem;
    }

    @media ${device.desktop} {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      margin-top: 4rem;
    }

    &.preload * {
      animation: none !important;
      transition: none !important;
    }

    & > a {
      flex: 0 0 100%;
      overflow: hidden;
      padding: 3.2rem 2.4rem;
      position: relative;

      @media ${device.tablet} {
        padding: 3.2rem 4rem;

        &:last-child {
          margin-right: 0;
        }

        &:nth-child(n + 4) {
          margin-top: 1.6rem;
        }
      }
    }
  }

  .reset-button {
    border: none;
  }

  .multi-select {
    border-radius: 0;

    .dropdown-container {
      border-radius: 0;
    }
  }
  .dropdown-content * {
    border-radius: 0 !important;
  }
`;
const TransactionLanding = (props) => {
  const { resourceStrings } = useLocalization();
  const industryFilterLabel = resourceStrings['bdO.Transactions.IndustryFilterLabel'];
  const serviceFilterLabel = resourceStrings['bdO.Transactions.ServiceFilterLabel'];
  const engagementFilterLabel = resourceStrings['bdO.Transactions.EngagementFilterLabel'];
  const resetButtonText = resourceStrings['bdO.Transactions.ResetButtonText'];
  const [industryValue, setIndustryValue] = useState([]);
  const [serviceValue, setServiceValue] = useState([]);
  const [engagementValue, setEngagementValue] = useState([]);
  const { transactionFilters, transactions, description } = props;

  const getFilteredArray = (filterText) =>
    transactionFilters
      .filter(({ filterType }) => filterType === filterText)
      .map(({ filterName }) => ({ label: filterName, value: filterName }));

  const industryFilters = getFilteredArray('Industry');
  const serviceFilters = getFilteredArray('Service');
  const engagementTypeFilters = getFilteredArray('Engagement Type');
  const compareFilterToTransaction = (transactionFilter, valueFilter) =>
    transactionFilter
      .split('|')
      .some((element) => valueFilter.map((valueObject) => valueObject.value).includes(element));

  const clearAll = () => {
    window.location.reload(false);
  };

  const applyFilter = () => {
    let result = transactions;
    if (industryValue.length > 0) {
      result = result.filter(({ transactionIndustry }) =>
        compareFilterToTransaction(transactionIndustry, industryValue)
      );
    }
    if (serviceValue.length > 0) {
      result = result.filter(({ transactionService }) =>
        compareFilterToTransaction(transactionService, serviceValue)
      );
    }
    if (engagementValue.length > 0) {
      result = result.filter(({ transactionType }) =>
        compareFilterToTransaction(transactionType, engagementValue)
      );
    }
    return result;
  };

  const filteredTransactions = applyFilter();

  return (
    <FilterDivStyled>
      <div className="filter-area-container">
        <h2>Filter By</h2>
        <fieldset>
          <div className="filter-selection-container">
            <div className="filter-selection-item">
              <div className="preview-values">
                <label id="industries-label">{industryFilterLabel}</label>
              </div>
              <MultiSelect
                className="multi-select"
                onChange={setIndustryValue}
                options={industryFilters}
                value={industryValue}
                labelledBy="industries-label"
              />
            </div>
            <div className="filter-selection-item">
              <div className="preview-values">
                <label id="service-label">{serviceFilterLabel}</label>
              </div>

              <MultiSelect
                className="multi-select"
                onChange={setServiceValue}
                options={serviceFilters}
                value={serviceValue}
                labelledBy="service-label"
              />
            </div>
            <div className="filter-selection-item">
              <div className="preview-values">
                <label id="engagement-label">{engagementFilterLabel}</label>
              </div>
              <MultiSelect
                className="multi-select"
                onChange={setEngagementValue}
                options={engagementTypeFilters}
                value={engagementValue}
                labelledBy="engagement-label"
              />
            </div>
          </div>
        </fieldset>
        <button className="reset-button btn btn-primary" onClick={clearAll}>
          {resetButtonText}
        </button>
        <p>{description}</p>
      </div>
      <div className="transaction-section-container">
        {filteredTransactions.map((item) => (
          <div key={item.nodeID} className="transaction-item-container">
            <TransactionCard transaction={item} />
          </div>
        ))}
      </div>
    </FilterDivStyled>
  );
};

export default withLocalization(TransactionLanding);
